import React, { useState  } from 'react';
import { useNavigate } from "react-router-dom";

const SelectOutlate = () => {
  const navigate = useNavigate();
  const outlatedata = JSON.parse(localStorage.getItem("LoginUserData"));
  const [selectedOutletId, setSelectedOutletId] = useState("");

  const handleSelectChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedOutletId(selectedId);

    const selectedOutlet = outlatedata.user_Outlate.find(
      (outlet) => outlet.outlate_id === selectedId
    );

    if (selectedOutlet) {
      localStorage.setItem("SelectedOutlet", JSON.stringify(selectedOutlet));
      alert(`Selected: ${selectedOutlet.Outlate_Name}`);
      navigate("/LiveTableStatus")
    }
  };


 

  return (
    <div className="container mt-4">
      <h4 className='text-center'>Select Outlet</h4>
     <div className='row justify-content-center'>
     <div className='col-6'>
     {outlatedata?.user_Outlate?.length > 0 ? (
        <select
          className="form-select"
          value={selectedOutletId}
          onChange={handleSelectChange}
        >
          <option value="">-- Select an Outlet --</option>
          {outlatedata.user_Outlate.map((outlet) => (
            <option key={outlet.outlate_id} value={outlet.outlate_id}>
              {outlet.Outlate_Name}
            </option>
          ))}
        </select>
      ) : (
        <p>No outlets available</p>
      )}
    
     </div>
     
     </div>

    
    </div>
  );
};

export default SelectOutlate;
